/* eslint-disable jsx-a11y/anchor-is-valid */
import './startoverComponent.scss';

function StartoverComponent() {
  return (
    <div
      id="the_end_div"
      className="callout callout-black callout-override"
      style={{ display: 'block', backgroundColor: '#E5F1EC', borderBottom: '2px solid #077844' }}
    >
      <h5>Payment Info</h5>
      <h6>
        Payer Authentication completed!<a href=""> Start again?</a>
      </h6>
    </div>
  );
}

export default StartoverComponent;
